import React from 'react';
import LandingPage from "..";
import ButtonActualizar from './buttons/ButtonActualizar';
import ButtonActualizarAhora from './buttons/ButtonActualizarAhora';
import ButtonActualizarAlApagar from './buttons/ButtonActualizarAlApagar';
import ButtonSalir from './buttons/ButtonSalir';
import Page01 from "./pages/01";
import Page02 from "./pages/02";
import Page03 from './pages/03';
import LastPage from "./pages/LastPage";
import './LandingPageSTB.css';
import Utils from '../../../utils/Utils';
import { Redirect } from 'react-router';

const pages = [
    <Page01 />,
    <Page02 buttons={[ButtonActualizar]}/>,
    <Page03 buttons={[ButtonActualizar]}/>
]

export default function LandingPageSTB({history}) {

    const metadataDefaultValue = JSON.stringify({
        enable: true,
        landings: {
            total: 5,
            visibles: [1, 2, 3, 4 ]
        },
        updateForced: {enable: true},
        updateShutdown: {enable: true}
    });

    const {
        enable,
        landings: {visibles: visibleLandings},
        // updateForced: {enable: isEnabledUpdateForced},
        updateShutdown: {enable: isEnabledUpdateShutdown}
    } = Utils.getApaMetadataKey('migration_landing_config', metadataDefaultValue)
    
    const pagesToShow = pages.filter((_, index) => visibleLandings.includes(index + 1))

    if(!enable) {
        return <Redirect to={'/'} />
    }

    return (
        <LandingPage 
            history={history}
            pages={pagesToShow}
            lastSpecialPage={
                <LastPage buttons={[
                    ButtonActualizarAhora, 
                    ... isEnabledUpdateShutdown ? [ButtonActualizarAlApagar] : [],
                    ButtonSalir
                ]}
                />}
            />
    )
}


// WEBPACK FOOTER //
// ./src/components/LandingPage/LandingPageSTB/index.jsx